import { GetAllOfferRequestsForAdminState } from './getAllOfferRequestsForAdmin.types'

const initialState: GetAllOfferRequestsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
